export default "__VITE_ASSET__CRmZrygk__"